import { BaseApiModel } from './BaseApiModel';

export class AppraisalMeasurements extends BaseApiModel {
  public appraisalId: number;
  public modelAccordingToComponentBook: string;
  public modelAccordingToApprovalOrder: string;
  public measurementStandard: string;
  public calibrationLicence: string;
  public code: string;
  public standardSpeed: number;
  public recordedSpeed: number;
  public result: string;
  public situation: string;
  public situationEnd: string;
}
